import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import messages from '../../redux/messages';
import diagnosisServices from './diagnosis.services';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getDiagnosis = (params, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_DIAGNOSIS,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};

    // const resp = await client.get(iType === 1 ? '/api/app/Formal_Diagnostico/' : '/api/app/Funcional_Diagnostico/', {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   },
    //   params: data
    // });
    const resp = await diagnosisServices.getDiagnosiss(params, iType);
    dispatch({
      type: actions.GET_DIAGNOSIS,
      payload: {
        diagnosis: resp.data.data,
        diagnosisLength: resp.data.count
      }
    });
    dispatch({
      type: actions.DIAGNOSIS_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.DIAGNOSIS_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADING_DIAGNOSIS,
      payload: false
    });
  }
}

export const saveDiagnosis = (req, iType, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_DIAGNOSIS,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.post(iType === 1 ? '/api/app/Formal_Diagnostico/' : '/api/app/Funcional_Diagnostico/', data, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   }});
    const resp = await diagnosisServices.saveDiagnosis(req, iType);
    const { diagnosis, diagnosisLength } = getState().diagnosis;
    const aDiagnosis = [...diagnosis, resp.data];
    dispatch({
      type: actions.GET_DIAGNOSIS,
      payload: {
        diagnosis: aDiagnosis,
        diagnosisLength: diagnosisLength + 1
      }
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    setShowModal(false)
    dispatch({
      type: actions.SAVE_LOADER_DIAGNOSIS,
      payload: false
    });
  }
}

export const editDiagnosis = (req, id, index, iType, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_DIAGNOSIS,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.put(iType === 1 ? `/api/app/Formal_Diagnostico/${id}/` : `/api/app/Funcional_Diagnostico/${id}/`, data, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    const resp = await diagnosisServices.editDiagnosis(id, req, iType);
    const { diagnosis, diagnosisLength } = getState().diagnosis;
    diagnosis[index] = resp.data;
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_DIAGNOSIS,
      payload: {
        diagnosis: diagnosis,
        diagnosisLength: diagnosisLength
      }
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    setShowModal(false)
    dispatch({
      type: actions.SAVE_LOADER_DIAGNOSIS,
      payload: false
    });
  }
}

export const deleteDiagnosis = (id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_DIAGNOSIS,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // await client.delete(iType === 1 ? `/api/app/Formal_Diagnostico/${id}/` : `/api/app/Funcional_Diagnostico/${id}/`, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    await diagnosisServices.deleteDiagnosis(id, iType);
    const { diagnosis, diagnosisLength } = getState().diagnosis;
    diagnosis.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_DIAGNOSIS,
      payload: {
        diagnosis: diagnosis,
        diagnosisLength: diagnosisLength -1
      }
    });
    dispatch({
      type: actions.DIAGNOSIS_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.DIAGNOSIS_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADING_DIAGNOSIS,
      payload: false
    });
  }
}
